<script>
/* global axios */
import { mapActions, mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

  export default{
    props:{
      appointmentId:{ type: String, default: null },
      resetModal:{ type: Function, default: () => {} },
      refreshDetails:{ type: Function, default: () => {} },
      staff_notes:{ type: String, default: 'There are no notes for this appointment.' },
    },
    data(){ return{ staff_note: '' } },
    emits: ["resetModal", "refreshDetails"],
    computed:{
        ...mapGetters({ currentAccountId: 'getCurrentAccountId' }),
        proxyBase() { return `/api/v1/accounts/${this.currentAccountId}/proxy/knowledge`; },
    },
    mounted(){ this.staff_note = this.staff_notes; },
    methods:{
      async editStaffNotes(payload){
            try{
                await axios.put(
                  `${this.proxyBase}/accounts/${this.currentAccountId}/appointments/${this.appointmentId}/notes`,
                  payload
                );
                useAlert(this.$t('APPOINTMENTS.EDITSTAFFNOTESMODAL.SUCCESS_MESSAGE'));
                this.$emit('refreshDetails');
                this.$emit('resetModal');
            }catch(err){
                console.error(err);
                useAlert(err);
            }
        }
  },
}
</script>

<template>
  <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
    <label class="block mb-4">
      <span class="text-sm font-medium text-slate-700 dark:text-slate-300">{{ $t('APPOINTMENTS.EDITSTAFFNOTESMODAL.DESCRIPTION_LABEL') }}</span>
      <textarea
        v-model="staff_note"
        rows="3"
        :placeholder="$t('APPOINTMENTS.EDITSTAFFNOTESMODAL.TEXTAREA_PLACEHOLDER')"
        class="mt-1 w-full p-3 border rounded-md text-slate-900 dark:text-white dark:bg-slate-700 dark:border-slate-600 focus:ring-2 focus:ring-woot-500 focus:outline-none"
      ></textarea>
    </label>

    <div class="flex gap-2 mt-4">
      <button 
        @click="editStaffNotes({ 'staff_note': staff_note })"
        class="w-full py-2 text-white font-medium rounded-md transition bg-woot-600 hover:bg-woot-700 focus:ring-2 focus:ring-woot-400 focus:outline-none"
      >
        {{ $t('APPOINTMENTS.EDITSTAFFNOTESMODAL.SAVE_BUTTON') }}
      </button>
      <button 
        @click="$emit('resetModal')"
        class="w-full py-2 text-slate-700 dark:text-slate-300 font-medium rounded-md border border-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition"
      >
        {{ $t('APPOINTMENTS.EDITSTAFFNOTESMODAL.CANCEL_BUTTON') }}
      </button>
    </div>
  </div>
</template>

